import { useState } from 'react';
import { routes } from '../../constants';
import { ClickOutside } from '../common/ClickOutside';
import { NavBarSubItem } from './NavBarSubItem';
import { useHistory } from 'react-router-dom';

export const PrimaryMarketMenuItem = () => {
    const history = useHistory();
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded(!expanded);

    const isActive = () => {
        const { pathname } = history.location;
        return pathname.includes('issuance-monitor') || pathname.includes(routes.loanMonitor)
            ? 'active'
            : '';
    };

    return (
        <li className={`navbar-item dropdown dropdown-with-badge ${expanded ? 'show' : ''}`}>
            <button
                type="button"
                className={`btn-link navbar-link dropdown-toggle ${isActive()}`}
                onClick={toggleExpanded}
            >
                <span className="new-label">new</span>
                Primary
            </button>
            <div className={`dropdown-menu navbar-dropdown-menu navbar-dropdown-manage ${expanded ? 'show' : ''}`}>
                {expanded && (
                    <ClickOutside onClick={() => setExpanded(false)}>
                        <>
                            <NavBarSubItem
                                onClick={toggleExpanded}
                                path={routes.imUrl()}
                                title="Issuance Monitor"
                            />
                            <NavBarSubItem
                                onClick={toggleExpanded}
                                path={routes.loanMonitor}
                                title="Loan Monitor"
                            />
                        </>
                    </ClickOutside>
                )}
            </div>
        </li>
    );
};
